<template>
  <div id="browse">
    <el-row :gutter="20">
      <el-col :span="16" :offset="4">
        <div class="container1">
          <el-tabs type="border-card" @tab-click="closeTable">
            <!--      单个基因搜索-->
            <el-tab-pane>
              <span slot="label">Gene Browser</span>
              <div class="title">
                <br>
                <p style="font-size: 17px">
                  <strong>Gene Browser</strong></p>
              </div>
              <div>
                <el-row>
                  <el-col :span="12" :offset="6">
                    <div>
                      <el-form ref="form" :model="form" size="big">
                        <el-form-item>
                          <label>Gene:</label>
                          <el-input id="form-control" v-model="form.gene" placeholder="LPIN2"
                                    @keyup.enter.native="onSubmit1" autocomplete="off"></el-input>
                          <br>
                        </el-form-item>
                        <el-row>
                          <el-col :span="12" :offset="7">
                            <label>Match mode</label>
                            <el-form-item>
                              <el-select id="match-conf" v-model="form.rule">
                                <el-option label="Fuzzy match" value='1'>
                                  <option>Fuzzy match</option>
                                </el-option>
                                <el-option label="Exact match" value='2'>
                                  <option>Exact match</option>
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24" :offset="9">
                            <el-form-item>
                              <el-button class="searchbtn" type="primary" @click="onSubmit1">Search!</el-button>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <br>
                        <a>
                          <p class="help-label" style="margin-top: 15px;text-align: center">-- Examples of FPIA usage -- </p>
                        </a>
                      </el-form>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <!--融合基因搜索-->
            <el-tab-pane>
              <span slot="label">Fusion Browser</span>
              <div class="title">
                <br>
                <p style="font-size: 17px">
                  <strong>Fusion Browser</strong></p>
              </div>
              <div>
                <el-row>
                  <el-col :span="8" :offset="8">
                    <br>
                    <el-form :inline="true" class="demo-form-inline">
                      <el-form-item>
                        <label>Fusion:</label>
                        <el-input id="browser-text" v-model="form.fusion" placeholder="LPIN2--G065919"></el-input>
                        <el-col :span="4" :offset="10">
                          <el-button id="gobtn" type="primary" @click="onSubmit2">Go!</el-button>
                        </el-col>
                      </el-form-item>
                    </el-form>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <!--癌症搜索——穿梭框-->
            <el-tab-pane>
              <span slot="label">Cancer Browser</span>
              <div class="title">
                <br>
                <p style="font-size: 17px">
                  <strong>Cancer Browser</strong></p>
              </div>
              <div style="text-align: center">
                <el-transfer
                  style="text-align: left; display: inline-block"
                  v-model="value"
                  filterable
                  :render-content="renderFunc"
                  :titles="['Source', 'Target']"
                  :button-texts="['', '']"
                  :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }"
                  @change="handleChange"
                  :data="data">
                </el-transfer>
                <el-row>
                  <el-button type="primary" @click="onSubmit3" round>Go!</el-button>
                </el-row>
              </div>
            </el-tab-pane>
            <!--分割线-->
            <div v-show="isShow">
              <el-divider class="el-divider--horizontal"></el-divider>
            </div>
            <!--  表格-->
            <el-table
              v-loading="loading"
              v-show="isShow"
              :data="select_list.slice((currentPage-1)*PageSize,currentPage*PageSize)"
              stripe
              style="width: 100%"
              empty-text="No data available in table">
              <el-table-column
                align="center"
                sortable
                fixed
                prop="fusion"
                label="fusion"
                width="220">
                <template slot-scope="scope"> <el-link><router-link :to="{name:'jbrowse',query:{gene:scope.row.fields.fusion.split('--')[0]}}">{{ scope.row.fields.fusion.split('--')[0] }}</router-link></el-link>--<el-link><router-link :to="{name:'jbrowse',query:{gene:scope.row.fields.fusion.split('--')[1]}}">{{ scope.row.fields.fusion.split('--')[1] }}</router-link></el-link></template>
              </el-table-column>
              <el-table-column
                sortable
                align="center"
                prop="cancer"
                label="cancer"
                width="110">
                <template slot-scope="scope"> {{ scope.row.fields.cancer }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="sample"
                label="sample"
                width="150">
                <template slot-scope="scope"> {{ scope.row.fields.sample }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                sortable
                prop="reads"
                label="reads"
                width="90">
                <template slot-scope="scope"> {{ scope.row.fields.reads }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="breakpoint1"
                label="breakpoint1"
                width="120">
                <template slot-scope="scope"> {{ scope.row.fields.breakpoint1 }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="breakpoint2"
                label="breakpoint2"
                width="120">
                <template slot-scope="scope"> {{ scope.row.fields.breakpoint2 }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                fixed="type"
                label="type"
                width="100">
                <template slot-scope="scope"> {{ scope.row.fields.type }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="confidence"
                label="confidence"
                width="104">
                <template slot-scope="scope"> {{ scope.row.fields.confidence }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="source"
                label="source"
                width="104">
                <template slot-scope="scope"> {{ scope.row.fields.source }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="Operation"
                label="Operation"
                width="120">
                <template slot-scope="scope">
                  <el-button type="primary" @click='add(scope.row.fields.fusion)'>Add</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tabs>
          <!--    分页操作-->
          <div style="margin-top: 30px">
            <el-pagination
              class="el-pager"
              background
              v-show="isShow"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageSizes"
              :page-size="PageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="select_list.length">
            </el-pagination>
          </div>
          <!--    弹窗-->
          <el-dialog
            style="margin-top: 65vh; width: 100%;"
            :modal="false"
            :close-on-click-modal="false"
            :visible.sync="centerDialogVisible"
            width="100%"
            center>
            <el-input
              placeholder="请输入内容"
              v-model="analysisfusion"
              clearable>
            </el-input>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="analysisJump">Analysis in functionalities</el-button>
      </span>
          </el-dialog>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    const generateData = _ => {
      const data = [];
      const cancers = ['ACC', 'BLCA', 'BRCA', 'CESC', 'CHOL', 'COAD', 'DLBC', 'ESCA', 'GBM', 'HNSC', 'KICH', 'KIRC', 'KIRP',
        'LAML', 'LGG', 'LIHC', 'LUAD', 'LUSC', 'MESO', 'OV', 'PAAD', 'PCPG', 'PRAD', 'READ', 'SARC', 'SKCM', 'STAD', 'TGCT',
        'THCA', 'THYM', 'UCEC', 'UVM'];
      cancers.forEach((cancer, index) => {
        data.push({
          label: cancer,
          key: cancer,
        });
      });
      return data;
    };

    return {
      form: {
        gene: '',
        rule: '',
        fusion: '',
      },
      select_list: [],
      isShow: false,
      data: generateData(),
      value: [],
      // 分页
      // 默认显示第几页
      currentPage: 1,
      // 个数选择器（可修改）
      pageSizes: [20, 50, 100, 200, 300, 400],
      // 默认每页显示的条数（可修改）
      PageSize: 20,

      centerDialogVisible: false,
      analysisfusion: '',
      loading:true
    }
  },

//点击按钮
  methods: {
    onSubmit1() {
      this.select_list=[]
      this.selectGeneFusions();
    },
    onSubmit2() {
      this.select_list=[]
      this.selectFusionFusions();
    },
    onSubmit3() {
      this.select_list=[]
      this.selectCancerFusions();
    },

    //重置表格
    closeTable() {
      this.isShow = false
      this.form.gene = ''
      this.form.rule = ''
      this.form.fusion = ''
      this.value = []
    },

    handleChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys);
    }
    ,
    // 单个基因搜索
    selectGeneFusions() {
      if (this.form.gene == '') {
        this.form.gene = "LPIN2"
      }
      this.loading=true
      if (this.form.rule =='1') {
        this.$http.get('http://bioinfo-sysu.com:9000/api/select_gene_fusions1?gene=' + this.form.gene)
          .then((response) => {
            var res = JSON.parse(response.bodyText)
            if (res.respCode === '000000') {
              this.select_list = res['list']
              this.loading=false
            }
          })
        this.isShow = true
      } else if (this.form.rule == '2') {
        this.$http.get('http://bioinfo-sysu.com:9000/api/select_gene_fusions2?gene=' + this.form.gene)
          .then((response) => {
            var res = JSON.parse(response.bodyText)
            if (res.respCode === '000000') {
              this.select_list = res['list']
              this.loading=false
            }
          })
        this.isShow = true
      }
    },
    //融合基因搜索
    selectFusionFusions() {
      if (this.form.fusion == '') {
        this.form.fusion = "LPIN2--G065919"
      }
      this.$http.get('http://bioinfo-sysu.com:9000/api/select_fusion_fusions?fusion=' + this.form.fusion)
        .then((response) => {
          var res = JSON.parse(response.bodyText)
          if (res.respCode === '000000') {
            this.select_list = res['list']
          }
        })
      this.isShow = true

    },
    //癌症搜索
    selectCancerFusions() {
      this.loading=true
      if (this.value != '') {
        this.$http.get('http://bioinfo-sysu.com:9000/api/select_cancer_fusions?cancer=' + this.value)
          .then((response) => {
            var res = JSON.parse(response.bodyText)
            if (res.respCode === '000000') {
              this.select_list = res['list']
              this.loading=false
            }
          })
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    //分页
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val
    },
    //添加分析
    add(fusion) {
      this.centerDialogVisible = true
      if (this.analysisfusion.indexOf(fusion) == -1) {
        this.analysisfusion = this.analysisfusion + fusion + ','
      }
    },
    //携带跳转
    analysisJump() {
      this.$router.push({
        path: "/functionalities",
        query: {fusion: this.analysisfusion.substring(0, this.analysisfusion.length - 1)}
      })
    }
  }
}
</script>

<style scoped>
.transfer-footer {
  margin-left: 20px;
  padding: 6px 5px;
}

span {
  font-size: 15px;
}

.el-dialog__wrapper {
  pointer-events: none;
}

/deep/ .el-dialog {
  pointer-events: auto;
}

el-tabs {
  width: 100%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.container1 {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  display: block;
}

.title {
  width: 100%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  display: block;
}

label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 16px;
  cursor: default;
}

#form-control {
  height: 35px;
  display: block;
  width: 100%;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  font-family: inherit;
  margin: 0;
}

#match-conf {
  border-radius: 4px;
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  font-family: inherit;
  text-transform: none;
  margin: 0;
  -webkit-writing-mode: horizontal-tb !important;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-indent: 0px;
  text-shadow: none;
  text-align: start;
  appearance: auto;
  align-items: center;
  white-space: pre;
  -webkit-rtl-ordering: logical;
  cursor: default;
  box-sizing: border-box;
}

option {
  font-weight: normal;
  display: block;
  white-space: nowrap;
  min-height: 1.2em;
  padding: 0px 2px 1px;
}

.searchbtn {
  width: 20%;
  height: 34px;
  border-color: #ccc;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  font-family: inherit;
  text-transform: none;
  overflow: visible;
  margin: 0;
}

.help-lab
el {
  margin-top: 15px;
  text-align: center;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

a {
  color: #337ab7;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
}

#browser-text {
  height: 35px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: table-cell;
  position: relative;
  z-index: 2;
  float: left;
  width: 100%;
  margin-bottom: 0;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  margin: 0;
  font: inherit;
  box-sizing: border-box;
  -webkit-writing-mode: horizontal-tb !important;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  text-align: start;
  appearance: auto;
  -webkit-rtl-ordering: logical;
  border-collapse: separate;
  cursor: text;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

#gobtn {
  width: 100%;
  height: 34px;
  border-color: #ccc;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  font-family: inherit;
  text-transform: none;
  overflow: visible;
  margin: 0;
}

.el-divider--horizontal {
  margin: 8px 0;
  background: 0 0;
  border-top: 1px dashed #e8eaec;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue